import {
  createWithHooks,
  useSnapshot,
  useSubscribe,
  withUseSnapshot,
  withUseSubscribe
} from "./chunk-SADGDJAJ.js";
import {
  createVanilla,
  deepEqual,
  devtools,
  getSnapshot,
  produce,
  ref,
  setGlobalNotifyInSync,
  snapshot,
  subscribe,
  withDerived,
  withSnapshot,
  withSubscribe
} from "./chunk-W2YTH3FF.js";

// src/enhancers/react/with-use-derived.ts
function withUseDerived(store, mapFn = (s) => s) {
  const storeWithDerived = withDerived(store, mapFn);
  return {
    ...storeWithDerived,
    useDerived: (options = {}) => {
      return useSnapshot(store.mutate, mapFn, options);
    }
  };
}

// src/react/use-reactive.ts
import { useRef } from "react";
function useReactive(initialState, options = {}) {
  const store = useCreation(() => createWithHooks(initialState), [initialState]);
  return [store.useSnapshot({ ...options }), store.mutate];
}
function useCreation(create, currDeps) {
  const { current: creation } = useRef({});
  if (!creation.created || !deepEqual(creation.preDeps, currDeps)) {
    creation.value = create();
    creation.created = true;
    creation.preDeps = currDeps;
  }
  return creation.value;
}
export {
  createWithHooks as create,
  createVanilla,
  devtools,
  getSnapshot,
  produce,
  ref,
  setGlobalNotifyInSync,
  snapshot,
  subscribe,
  useReactive,
  useSnapshot,
  useSubscribe,
  withDerived,
  withSnapshot,
  withSubscribe,
  withUseDerived,
  withUseSnapshot,
  withUseSubscribe
};
